<template>
  <div id="posting-view" class="relative overflow-hidden">
    <div class="vx-row">
      <div class="vx-col w-full mb-base" >
        <vx-card  ref="contentCard" :title="$t('GradeControl.Posting.LocationList')"  class="mb-8" title-color="black" refresh-content-action @refresh="getForecastStats">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="5" vs-sm="5" vs-xs="12" class="m-1">
              <div class="vx-row">
                <div class="vx-col w-full" >
                  <form-label>{{$t('GradeControl.Forecast.ForecastList')}}</form-label>
                  <forecast-selection @valueChanged="onPeriodChanged"></forecast-selection>
                </div>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="3" >
              <vx-tooltip :text="$t('Post')" class="mr-5" position="bottom" delay=".3s">
                <feather-icon icon="CheckCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openPostConfirm" />
              </vx-tooltip>
              <vx-tooltip :text="$t('CancelPost')" position="bottom" delay=".3s" class="mr-3" >
                <feather-icon icon="XCircleIcon" class="cursor-pointer" svg-classes="h-6 w-6" @click="openCancelPostingConfirm" />
              </vx-tooltip>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mb-2" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" >
              <h4>{{$t('GradeControl.Sample.SampleReceivedAuRate')}} : {{ $options.filters.toPercentage(overallAuReceivedSampled) }}</h4>
            </vs-col>
           </vs-row>
           <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" >
              <h4>{{$t('GradeControl.Sample.SampleReceivedBaseRate')}} : {{ $options.filters.toPercentage(overallBaseReceivedSampled) }}</h4>
            </vs-col>
           </vs-row>
          <forecast-location-grid ref="forecastLocationGrid" 
              @onCancelPosting="cancelPosting"></forecast-location-grid>
        </vx-card>
      </div>  
    </div>
  </div>
</template>
<script>

import { FormLabel } from "../../../shared/components";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import ForecastLocationGrid from "./components/ForecastLocationGrid.vue"
import ForecastSelection from "./../components/ForecastSelection.vue"

export default {
  components: {
    FormLabel,
    ForecastLocationGrid,
    ForecastSelection
  },
  data() {
    return {
      selectedProjectId: null,
      selectedLocationForecast: null,
      gradeCalculation: [],
      postedLocations: null,
      selectedPeriod: null
    };
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);
  },
  computed: {
    overallAuReceivedSampled() {
      if (this.$store.state.gradeControl.forecastStatsList.length > 0) {
        const val = this.$store.state.gradeControl.forecastStatsList.reduce(function(previousValue, currentValue) {
          return {
            receivedAuSamples: previousValue.receivedAuSamples + currentValue.receivedAuSamples,
            totalSamples: previousValue.totalSamples + currentValue.totalSamples
          }
        });
        return val.totalSamples === 0 ? 0 : val.receivedAuSamples / val.totalSamples * 100;
      } else {
        return null;
      }
    },
    overallBaseReceivedSampled() {
      if (this.$store.state.gradeControl.forecastStatsList.length > 0) {
        const val = this.$store.state.gradeControl.forecastStatsList.reduce(function(previousValue, currentValue) {
          return {
            receivedBaseSamples: previousValue.receivedBaseSamples + currentValue.receivedBaseSamples,
            totalSamples: previousValue.totalSamples + currentValue.totalSamples
          }
        });
        return val.totalSamples === 0 ? 0 : val.receivedBaseSamples / val.totalSamples * 100;
      } else {
        return null;
      }
    }
  },
  methods: {
    onPeriodChanged(val) {
      this.selectedPeriod = val;
      this.$refs.contentCard.refreshcard();
    },
    getForecastStats() {
      if (this.selectedPeriod && this.selectedProjectId) {
        this.$refs.forecastLocationGrid.fetchStats(this.selectedProjectId, this.selectedPeriod.startDate, this.selectedPeriod.endDate).then(() => { 
          this.$refs.contentCard.removeRefreshAnimation();
        });
      }
      else {
        this.$refs.contentCard.removeRefreshAnimation()
      }
    },
    openPostConfirm() {
      const forecastIds = this.$refs.forecastLocationGrid.getSelectedUnpostedForecasts();
      if (forecastIds.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Post"),
          text: this.$t('GradeControl.Posting.NoForecastSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Post"),
          text: this.$t('GradeControl.Posting.ConfirmPost'),
          accept: this.postForecast
        });
      }
    },
    postForecast() {
      const forecastIds = this.$refs.forecastLocationGrid.getSelectedUnpostedForecasts();
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/LocationPosting/', {
        locationForecastsId: forecastIds,
        projectId: this.selectedProjectId
      }).then((result) => {
        if (result.data) {
          this.$vs.notify({
            title: this.$t("Import"),
            text: this.$t("GradeControl.Posting.PostCompleted"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });

          this.$refs.contentCard.refreshcard();
        }
      }).finally(() => {
        this.$vs.loading.close();
      });
    },

    openCancelPostingConfirm() {
      const forecastIds = this.$refs.forecastLocationGrid.getSelectedPostedForecastLocation();
      if (forecastIds.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Post"),
          text: this.$t('GradeControl.Posting.NoPostedLocationSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Post"),
          text: this.$t('GradeControl.Posting.ConfirmCancelPostingBatch'),
          accept: this.cancelPostingBatch
        });
      }
    },
    cancelPostingBatch() {
      const forecastIds = this.$refs.forecastLocationGrid.getSelectedPostedForecastLocation();
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/LocationPosting/CancelPosting/', {
        locationForecastsId: forecastIds
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Post"),
          text: this.$t("GradeControl.Posting.CancelPostingCompletedBatch"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
  
        this.$refs.contentCard.refreshcard();
      
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    cancelPosting(locationForecast) {
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/LocationPosting/CancelPosting/', {
        locationForecastsId: [locationForecast.locationForecastId]
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Post"),
          text: this.$t("GradeControl.Posting.CancelPostingCompleted"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
  
        this.$refs.contentCard.refreshcard();
      
      }).finally(() => {
        this.$vs.loading.close();
      });
    }
  }
};
</script>
<style lang="scss">
#forecast-view {
  .vs-sidebar--background {
    position: absolute;
  }
  .full-vs-sidebar {
    .vs-sidebar {
      max-width: 100%;
    }
  }

  .con-vs-popup {
    .vs-popup {
      width: 1200px !important;
      height: auto !important;
    }
  } 

  .select-all-chexkbox{
      .vs-checkbox{
          margin-right: 0.8rem;
      }
  }

  .location-content-scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 100px);

      &:not(.ps) {
        overflow-y: auto;
      }
  }

  .scroll-area-location-content {
    position: relative;
    margin: auto;
    width: 100%;
    height: calc(100% - 6.3%);

    &:not(.ps) {
      overflow-y: auto;
    }
  }

  .location-view-sidebar {
    .vs-sidebar{
        background-color: #f8f8f8 !important;
        border-left: 1px solid #dae1e7;
    }

    .location-header{
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
        border-bottom: 1px solid #eee;
        z-index: 1;
        position: relative;
    }

    .mail__attachment {
      .vs-chip--text {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
  
  .list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }

  
}

</style>
